<h3 mat-dialog-title>Filtrar Gestão de Relacionamento</h3>
<div mat-dialog-content style="width: 100%">

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field 
            appearance="outline" 
            fxLayoutAlign="start" 
            floatLabel="always" 
            fxFlex="45"
        >
            <mat-label>Data Início</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker" 
                [formControl]="data_hora_operacao_inicio" 
                name="data_hora_operacao_inicio" 
                placeholder="Data da Operação"
            >
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="data_hora_operacao_inicio.hasError('required') && data_hora_operacao_inicio.touched">
                Data de início é obrigatória
            </mat-error>
        </mat-form-field>

        <mat-form-field 
            appearance="outline" 
            fxLayoutAlign="end" 
            floatLabel="always" 
            fxFlex="45"
        >
            <mat-label>Data Fim</mat-label>
            <input 
                matInput 
                [matDatepicker]="pickerFim" 
                [formControl]="data_hora_operacao_fim" 
                name="data_hora_operacao_fim" 
                placeholder="Data da Operação"
            >
            <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
            <mat-datepicker #pickerFim></mat-datepicker>
            <mat-error *ngIf="data_hora_operacao_fim.hasError('required') && data_hora_operacao_fim.touched">
                Data de fim é obrigatória
            </mat-error>
        </mat-form-field>      
        
    </div>

    <mat-form-field appearance="outline" style="width: 100%"  floatLabel="always">
        <mat-label>Tipo de Registro</mat-label>
        <mat-select placeholder="Tipo"
                    [(value)]="model.tipo_registro" 
                    [formControl]="tipo_registro"
                    required name="tipo_registro" >
            <mat-option value="">TODO</mat-option>
            <mat-option value="atividade">Atividade</mat-option>
            <mat-option value="historico_relacionamento">Histórico de Relacionamento</mat-option>
            <mat-option value="oportunidade">Oportunidade</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
    </mat-form-field>

    <div 
        fxLayout="column" 
        fxLayoutAlign="start" 
        fxLayout.gt-md="row" 
    >
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%"  floatLabel="always">
            <mat-label>Cliente</mat-label>
            <input 
                matInput 
                placeholder="Digite o nome ou conta de um cliente" 
                aria-label="Cliente"  
                [formControl]="cliente" 
                name="cliente" 
                [matAutocomplete]="auto"
            >
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>
    
    <mat-form-field appearance="outline" style="width: 100%"  floatLabel="always">
        <mat-label>Ação</mat-label>
        <mat-select 
            placeholder="Ação" 
            [(value)]="model.acao_id"
            [formControl]="acao_id">
            <mat-option value="">TODAS</mat-option>
            <mat-option *ngFor="let acao of listAcoes"
                [value]="acao.id">{{acao.nome}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerAcao"></mat-spinner> 
    </mat-form-field>

    <div fxLayout="column" fxLayout.gt-md="row" >        
        <mat-form-field appearance="outline" style="width: 100%" fxFlex="100"  floatLabel="always">
            <mat-label>Assunto de Atividade</mat-label>
            <mat-select 
                placeholder="Assunto"
                [(value)]="model.assunto_id" 
                [formControl]="assunto_id"
                name="assunto_id"
            >
                <mat-option value="">TODOS</mat-option>
                <mat-option *ngFor="let assunto of listAssuntos" [value]="assunto.id">
                    {{assunto.nome}}
                </mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAssunto"></mat-spinner>  
        </mat-form-field>    
    </div>       

    <mat-form-field 
        appearance="outline" 
        style="width: 100%" 
        *ngIf='habilitaEscritorios || usuario.role_id == 2 || usuario.role_id == 7 || usuario.role_id == 4'
        floatLabel="always"
    >
        <mat-label>Escritório</mat-label>
        <mat-select 
            placeholder="Escritório" 
            [(value)]="model.escritorio_id"
            [formControl]="escritorio_id" 
            (selectionChange)="selectEscritorio($event)">
            <mat-option value="">TODOS</mat-option>
            <mat-option *ngFor="let escritorio of listEscritorios"
                [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuario.role_id != 5'  floatLabel="always">
        <mat-label>Assessor</mat-label>
        <mat-select placeholder="Assessor"
                    [(value)]="model.assessor_id" 
                    [formControl]="assessor_id"
                    required name="assessor_id" >
            <mat-option value="">TODOS</mat-option>
            <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
    </mat-form-field>        

</div>
<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >   Cancelar
    </button>
    
    <button 
        mat-button 
        (click)="filtrar()" 
        tabindex="-1"
    >
        Filtrar
    </button>
</div>